module.exports = __webpack_public_path__ + "media/images/logito-758be8e6dbc734437f48464d74d4ec2b.jpg";